import { BaseStatementPagePath } from 'app/core/workflow/page-path/statement-page-path/base-statement-page.path';

export class ConfirmTaxReturnComponentPath extends BaseStatementPagePath {
  public static path(): string {
    return 'statement/:statementId/confirm-tax-return';
  }
}
